module.exports = __webpack_public_path__ + "static/img/logo.e4988b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/loader/img/logo.png
// module id = xc6P
// module chunks = 0